import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { CacheBuster } from 'ts-cacheable';
import { IssuerList } from 'src/app/issuer/model/issuerList';
import { IssuerEdit } from 'src/app/issuer/model/issuerEdit';

const issuersCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class IssuerService implements OnDestroy
{
  private messagingLanguageChangedSubscription: Subscription;

  constructor(private http: HttpClient) { }

  /**
   * Delete a Issuer.
   *
   * @param id Issuer id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: issuersCacheBuster
    })
  public deleteIssuer(id: number): Observable<IssuerList>
  {
    return this.http.delete<IssuerList>(`/issuer/${id}`);
  }

  /**
   * Save a Issuer.
   *
   * @param data Issuer to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: issuersCacheBuster
    })
  public saveIssuer(data: any, isNew: boolean, issuerId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/issuer', data);
    }
    else
    {
      return this.http.put(`/issuer/${issuerId}`, data);
    }
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get Issuer for grid list.
   */
  public getIssuerList(): Observable<IssuerList[]>
  {
    return this.http.get<IssuerList[]>('/issuers/list');
  }

  /**
   * Get Issuer by id.
   *
   * @param id Issuer id
   */
  public getIssuerById(id: number): Observable<IssuerEdit>
  {
    return this.http.get<IssuerEdit>(`/issuer/${id}`);
  }

  /**
   * Check if Issuer is in use
   *
   * @param id Issuer Id
   */
  public existsIssuer(id: number): Observable<any>
  {
    return this.http.get(`/issuer/inuse/${id}`);
  }

  /**
   * Check if Issuer Name exists to avoid name duplicates
   *
   * @param name Issuer Name
   */
  public existsIssuerName(name: string): Observable<any>
  {
    return this.http.get(`/issuer/exists?name=${name}`);
  }
}
